module.exports = {
  facebook: `https://www.facebook.com/LP-Brickwork-1036318383187369`,
  instagram: `https://www.instagram.com/lpbrickwork/`,
  phone: `07412 597890`,
  email: `info@lpbrickwork.co.uk`,
  primaryColor: `#56b6e8`,
  secondaryColor: `#595756`
};
